import * as React from "react";
import Svg, { Path } from "react-native-svg";

const ContestBadIcon = (props) => (
  <Svg
    width={95}
    height={95}
    viewBox="0 0 95 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M47.1486 94.9522C20.8878 94.9522 -0.261919 73.6852 0.00245173 47.0354C0.266823 21.7092 20.1828 -0.175429 47.6774 0.00106013C75.6126 0.177549 94.9116 22.2387 94.9998 47.3884C95.0879 76.5091 70.237 96.0993 47.1486 94.9522Z"
      fill="#FF7A00"
      fillOpacity={0.5}
    />
    <Path
      d="M47.6083 53.4388C57.6935 53.4388 66.911 59.498 70.4896 68.5338C71.2487 70.4472 72.1163 72.8922 69.4052 73.9552C67.0195 74.912 65.9351 73.1048 65.0675 71.0851C61.7058 63.7502 56.1753 59.3917 47.6083 59.3917C38.7161 59.3917 33.0771 63.8565 29.8238 71.6166C28.9563 73.4237 27.8719 74.6994 25.703 73.9552C23.3173 73.2111 23.5342 71.2977 24.1849 69.1716C27.5466 59.9232 37.0895 53.3325 47.6083 53.4388Z"
      fill="black"
      fillOpacity={0.86}
    />
    <Path
      d="M32.6043 34.3127C32.6043 35.7093 32.7212 37.1931 32.6043 38.5897C32.3705 40.5973 30.7341 41.6447 27.9288 41.5575C25.3572 41.4702 23.9546 40.4227 23.8377 38.5897C23.7208 35.7093 23.7208 32.8288 23.8377 29.9484C23.8377 27.8535 25.4741 26.7188 28.1625 26.7188C30.9679 26.7188 32.3705 27.9408 32.6043 29.9484C32.6043 31.4322 32.6043 32.8288 32.6043 34.3127Z"
      fill="black"
      fillOpacity={0.86}
    />
    <Path
      d="M71.198 34.3127C71.198 35.7093 71.3149 37.1931 71.198 38.5897C70.9643 40.5973 69.3278 41.6447 66.5225 41.5575C63.951 41.4702 62.5483 40.4227 62.4314 38.5897C62.3145 35.7093 62.3145 32.8288 62.4314 29.9484C62.4314 27.8535 64.0679 26.7188 66.7563 26.7188C69.5616 26.7188 70.9643 27.9408 71.198 29.9484C71.198 31.4322 71.198 32.8288 71.198 34.3127Z"
      fill="black"
      fillOpacity={0.86}
    />
  </Svg>
);

export default ContestBadIcon;
